/* src/components/AdPost.js - v1.0 - Feed-integrated AdSense unit (scaffold)
   Styled to match Post.js's .card/.card-header exactly, so it reads as an
   in-feed item rather than a banner - same pattern as the AdMob NativeAd
   treatment on the mobile app (see project_nsn_ad_monetization memory).

   INERT UNTIL WIRED UP: AD_ENABLED stays false and AD_SLOT_ID stays null
   until nubix.social passes AdSense review AND a real ad unit is created
   in the AdSense dashboard for it. Until then this component renders
   nothing - it's safe to leave mounted in Feed.js with zero effect on the
   live site. To activate: set AD_ENABLED to true and AD_SLOT_ID to the
   real data-ad-slot value from the AdSense dashboard, then verify a push
   actually renders in production before trusting it (AdSense can take a
   few page loads to start serving on a freshly enabled slot). */
import React, { useEffect, useRef } from 'react';

const AD_ENABLED = false;
const AD_CLIENT = 'ca-pub-3595170434836466';
const AD_SLOT_ID = null; // fill in once created in AdSense

function AdPost() {
  const pushedRef = useRef(false);

  useEffect(() => {
    if (!AD_ENABLED || !AD_SLOT_ID || pushedRef.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushedRef.current = true;
    } catch (e) {
      console.error('[AdPost] adsbygoogle push failed:', e);
    }
  }, []);

  if (!AD_ENABLED || !AD_SLOT_ID) return null;

  return (
    <div className="card" style={{
        position: 'relative',
        borderLeft: '6px solid #f9ab00',
        textAlign: 'left'
    }}>
      <div className="card-header" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          flexDirection: 'row',
          marginBottom: '15px',
          textAlign: 'left'
      }}>
        <div style={{ background: '#f9ab00', width: '40px', height: '40px', borderRadius: '50%', marginRight: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', flexShrink: 0, fontSize: '18px' }}>
            $
        </div>
        <div style={{ textAlign: 'left', flexGrow: 1 }}>
            <div style={{ fontWeight: 'bold' }}>Sponsored</div>
            <div style={{ fontSize: '0.75rem', opacity: 0.5 }}>Advertisement</div>
        </div>
      </div>

      <ins className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client={AD_CLIENT}
          data-ad-slot={AD_SLOT_ID}
          data-ad-format="fluid"
          data-ad-layout-key="-fb+5w+4e-db+86"
      />
    </div>
  );
}

export default AdPost;
